export const version = '2.9.26';
//# sourceMappingURL=version.js.map